export default __webpack_public_path__ + "dcc679e5a232886789342b2295bbef74.png";